// extracted by mini-css-extract-plugin
export var checkboxes = "Form-module--checkboxes--0093c";
export var checkmark = "Form-module--checkmark--4811d";
export var dataCaptureType = "Form-module--data-capture--type--51e0e";
export var error = "Form-module--error--6aeb5";
export var field = "Form-module--field--6b329";
export var focus = "Form-module--focus--bc45c";
export var form = "Form-module--form--5d59d";
export var formRow = "Form-module--formRow--101d6";
export var guidance = "Form-module--guidance--5c5a9";
export var input = "Form-module--input--8b208";
export var label = "Form-module--label--9ad6b";
export var response = "Form-module--response--08143";
export var select = "Form-module--select--1a59c";
export var textarea = "Form-module--textarea--d920b";
export var tickWrapper = "Form-module--tick-wrapper--1eb2f";